/**
 * Styled Components - Created by cazarez on 25/05/18.
 */

import styled from 'styled-components'
import Button from 'antd/lib/button'
import Tag from 'antd/lib/tag'
import { BLUE, BLUE_LIGHT, GRAY_STRONG, TRANSPARENT, WHITE } from '../../theme/colors'
import Icon from 'antd/lib/icon'

const { CheckableTag } = Tag

interface DivProps {
  disabled?: boolean
}

export const Container = styled.div`
  background-color: #fff;
`

export const Title = styled.div`
  margin-bottom: 10px;
  color: #5f6062;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
  @media (max-width: 1023px) {
    font-size: 17px;
  }
`

export const Subtitle = styled.div`
  max-width: 458px;
`

export const BodyDiv = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  margin-top: 14px;
  font-family: Avenir;
  @media (max-width: 1023px) {
    flex-flow: column;
  }
`

export const LeftSide = styled.div`
  flex: 1;
  display: flex;
  flex-flow: column;
  align-items: center;
  padding-right: 30px;
  margin-right: -10px;
  border-right: 1px solid #afafaf;
  @media (max-width: 1023px) {
    margin-right: 0px;
    padding-right: 0px;
    border-right: none;
    margin-bottom: -24px;
    padding-bottom: 30px;
    border-bottom: 1px solid #afafaf;
    width: 100%;
  }
`

export const RightSide = styled.div`
  flex: 1;
  text-align: center;
  margin-right: -8px;
  margin-left: 8px;
  @media (max-width: 1023px) {
    margin-right: 0px;
    margin-left: 0px;
  }
`

export const TeamstoresListContainer = styled.div`
  margin-bottom: 10px;
  width: 100%;
  border-radius: 7px;
  display: flex;
  flex-flow: column;
  margin-top: 4px;
  @media (max-width: 1023px) {
    align-items: center;
  }
`

export const CircleEmpty = styled.div`
  width: 13px;
  height: 13px;
  display: inline-block;
  border: 1px solid #dddddd;
  vertical-align: middle;
  border-radius: 25px;
  margin-right: 8px;
  margin-bottom: 2px;
`

export const CircleIcon = styled(Icon)`
  margin-right: 8px;
`

export const ListItem = styled(CheckableTag)`
  box-shadow: 1px 2px 3px -1px #c3c3c3;
  width: fit-content;
  margin-bottom: 10px;
  border-radius: 25px;
  height: fit-content;
  padding: 3px 14px;
  display: inline-block;
  font-size: 15px;
  font-weight: normal;
  margin-right: 18px;
  margin-left: 2px;
  padding-left: 8px;
  &.ant-tag {
    color: ${GRAY_STRONG};
    border-color: #f3f3f3;
  }
  &.ant-tag-checkable-checked {
    color: ${BLUE};
    border-color: ${BLUE};
    background: ${WHITE};
  }
  &.ant-tag-checkable:not(.ant-tag-checkable-checked):hover {
    color: ${BLUE_LIGHT};
  }
  &.ant-tag-checkable:active {
    background: ${TRANSPARENT};
  }
  @media (max-width: 1023px) {
    margin-right: 0px;
    margin-left: 0px;
  }
  ${({ disabled }: DivProps) => disabled ? `
    &.ant-tag, &.ant-tag-checkable-checked {
      background: #f2f2f2;
      box-shadow: none;
      color: ${GRAY_STRONG};
      border-color: #f3f3f3;
    }
    i {
      color: #bababa;
    }
    &:hover {
      cursor: not-allowed;
    }
  ` : ''}
`

export const ListTitle = styled.div`
  margin: 10px;
  height: 16px;
  color: #5f6062;
  font-size: 14px;
  letter-spacing: 0.15px;
  line-height: 16px;
  width: 100%;
  font-weight: bold;
  margin-left: 22px;
  @media (max-width: 1023px) {
    text-align: center;
    margin-left: 0px;
    font-size: 16px;
  }
`

export const AddTeamStoreButton = styled(Button)`
  height: 40px;
  background-color: ${BLUE};
  color: #fff;
  border-radius: 5px;
  border: none;
  box-shadow: 1px 2px 3px 0px #dadada;
  transition: all .25s;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
`

export const OrDiv = styled.div`
  margin-right: 6px;
  background: white;
  font-weight: 500;
  font-family: Avenir;
  padding: 3px 0;
  @media (max-width: 1023px) {
    margin-right: 0px;
    margin-top: 12px;
    margin-bottom: 14px;
    padding: 3px 8px;
  }
`

export const AddButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
`
export const AddDesignButton = styled(Button)`
  background-color: #4a90e2;
  color: #fff;
  border-radius: 5px;
  border: none;
  height: 40px;
  padding: 0 22px;
  box-shadow: 1px 2px 3px 0px #dadada;
  transition: all .25s;
  &:hover {
    background-color: #4a90e2;
    color: #fff;
    border-color: #4a90e2;
  }
  &:disabled {
    background: #e2e2e2;
  }
`

export const LoadingContainer = styled.div`
  height: 30vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SavingContainer = styled.div`
  display: flex;
  position: absolute;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background: #ffffff73;
  left: 0;
  top: 0;
  z-index: 10;
`

export const SavedContainer = styled.div`
  background-color: #fff;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-top: 12px;
`

export const SavedIcon = styled(Icon)`
  font-size: 36px;
  margin-bottom: 18px;
  margin-top: 10px;
  animation: fade-in-bottom-icon 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-bottom-icon {
    0% {
      transform: translateY(10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const StoreName = styled.div`
  font-weight: bold;
`

export const ButtonsBelow = styled.div`
  text-align: center;
  margin-top: 30px;
`

export const BackToLocker = styled.div`
  padding: 6px 16px;
  border-radius: 25px;
  box-shadow: 0px 2px 4px -1px #c6c6c6;
  margin-bottom: 18px;
  font-size: 14px;
  border-top: 1px solid #f3f3f3;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ViewStore = styled.div`
  padding: 6px 16px;
  border-radius: 25px;
  box-shadow: 0px 2px 4px -1px #c6c6c6;
  margin-bottom: 8px;
  font-size: 14px;
  border-top: 1px solid #f3f3f3;
  background: ${BLUE};
  color: ${WHITE};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AddToTeamStore/styledComponents.tsx